import { render, staticRenderFns } from "./ClaimPromoCodeDialog.vue?vue&type=template&id=565b5fb1"
import script from "./ClaimPromoCodeDialog.vue?vue&type=script&lang=js"
export * from "./ClaimPromoCodeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports